import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { memo, useMemo, useCallback } from 'react';
import Image from 'next/image';
import { HomeIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { customImageLoader, getAssetSrc } from '@restworld/utils-common';
import { Card, PrimaryList, CardSubTitle, CardTitle, RestaurantStatistics } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CardPrimary = function CardPrimary(_ref) {
  var _jobPositionDetails$r;

  var jobPositionDetails = _ref.jobPositionDetails,
      showRestaurant = _ref.showRestaurant,
      showViolaBadge = _ref.showViolaBadge,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'white' : _ref$variant,
      twStyle = _ref.twStyle;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var formatSalaryContract = useCallback(function (_ref2) {
    var salary = _ref2.salary,
        contractTerm = _ref2.contractTerm,
        shifts = _ref2.shifts,
        salaryMonthNumber = _ref2.salaryMonthNumber;
    return [].concat(_toConsumableArray(salary ? [{
      key: 'salary',
      subTitle: "".concat(salary),
      label: "".concat(t('pay')).concat(salaryMonthNumber ? " per ".concat(salaryMonthNumber, " ").concat(t('monthly_payment')) : ''),
      icon: 'CurrencyEuroIcon'
    }] : []), _toConsumableArray(contractTerm ? [{
      key: 'contract',
      subTitle: contractTerm,
      label: t('contract_title'),
      icon: 'DocumentTextIcon'
    }] : []), _toConsumableArray(shifts ? [{
      key: 'shifts',
      subTitle: shifts.subTitle,
      label: shifts.title,
      icon: 'ClockIcon'
    }] : []));
  }, [t]);
  var itemList = useMemo(function () {
    return formatSalaryContract(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, jobPositionDetails !== null && jobPositionDetails !== void 0 && jobPositionDetails.salary ? {
      salary: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.salary
    } : {}), jobPositionDetails !== null && jobPositionDetails !== void 0 && jobPositionDetails.contractTerm ? {
      contractTerm: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.contractTerm
    } : {}), jobPositionDetails !== null && jobPositionDetails !== void 0 && jobPositionDetails.shifts ? {
      shifts: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.shifts
    } : {}), {}, {
      salaryMonthNumber: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.salaryMonthNumber
    }));
  }, [formatSalaryContract, jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.contractTerm, jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.salary, jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.salaryMonthNumber, jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.shifts]);
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsxs(Card, {
      paddingType: "large",
      variant: variant,
      twStyle: twStyle,
      children: [showRestaurant && jobPositionDetails !== null && jobPositionDetails !== void 0 && jobPositionDetails.companyLogo ? /*#__PURE__*/_jsx(ImageWrapper, {
        children: /*#__PURE__*/_jsx(_StyledImage, {
          loader: customImageLoader,
          src: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.companyLogo,
          alt: "logo",
          width: 200,
          height: 200
        })
      }) : null, /*#__PURE__*/_jsx(PrimaryCardHeader, _objectSpread({}, _objectSpread({
        showRestaurant: showRestaurant,
        showViolaBadge: showViolaBadge,
        fontColor: variant === 'white' ? 'black' : 'white'
      }, jobPositionDetails ? {
        companyLogo: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.companyLogo,
        seasonalAccommodation: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.seasonalAccommodation,
        companyName: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.companyName,
        title: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.title,
        jobLocation: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.jobLocation,
        jobLocality: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.jobLocality
      } : {}))), jobPositionDetails !== null && jobPositionDetails !== void 0 && jobPositionDetails.restaurantCovers || jobPositionDetails !== null && jobPositionDetails !== void 0 && jobPositionDetails.restaurantStaffSize ? /*#__PURE__*/_jsx(RestaurantStatistics, {
        covers: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : jobPositionDetails.restaurantCovers,
        staffSize: jobPositionDetails === null || jobPositionDetails === void 0 ? void 0 : (_jobPositionDetails$r = jobPositionDetails.restaurantStaffSize) === null || _jobPositionDetails$r === void 0 ? void 0 : _jobPositionDetails$r.toString(),
        variant: 'vertical'
      }) : null, /*#__PURE__*/_jsx(PrimaryList, {
        itemList: itemList,
        type: variant === 'gradientBase' ? 'landing-card' : 'default'
      })]
    })
  });
};
export default CardPrimary;
export var PrimaryCardHeader = /*#__PURE__*/memo(function (props) {
  var showRestaurant = props.showRestaurant,
      companyLogo = props.companyLogo,
      seasonalAccommodation = props.seasonalAccommodation,
      companyName = props.companyName,
      title = props.title,
      inputJobLocation = props.jobLocation,
      jobLocality = props.jobLocality,
      _props$fontColor = props.fontColor,
      fontColor = _props$fontColor === void 0 ? 'black' : _props$fontColor,
      twStyle = props.twStyle,
      showViolaBadge = props.showViolaBadge; // Harcoded hiding of some specific keywords

  var jobLocation = useMemo(function () {
    return inputJobLocation ? inputJobLocation.replace('Coloreto, ', '') : inputJobLocation;
  }, [inputJobLocation]);
  var jobLocationEl = useMemo(function () {
    return showRestaurant && jobLocation || jobLocality ? /*#__PURE__*/_jsx(_StyledDiv, {
      children: /*#__PURE__*/_jsx(CardSubTitle, {
        textColor: fontColor === 'black' ? 'gray' : 'gray300',
        children: showRestaurant && jobLocation ? jobLocation : jobLocality
      })
    }) : null;
  }, [fontColor, jobLocality, jobLocation, showRestaurant]);
  return /*#__PURE__*/_jsxs(Header, {
    showRestaurant: Boolean(showRestaurant && companyLogo),
    twStyle: twStyle,
    children: [seasonalAccommodation ? /*#__PURE__*/_jsx(SeasonalAccommodation, {}) : null, showRestaurant ? /*#__PURE__*/_jsx(CardSubTitle, {
      textColor: fontColor === 'black' ? 'gray' : 'gray300',
      children: companyName
    }) : null, title ? /*#__PURE__*/_jsx(CardTitle, {
      textColor: fontColor,
      children: title
    }) : null, jobLocationEl, showViolaBadge && /*#__PURE__*/_jsx(ViolaBadge, {})]
  });
}); // --> parent > child components

var CardWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cardprimary__CardWrapper",
  componentId: "sc-1y6la3x-0"
})(["", ";"], {
  "width": "100%",
  "@media (min-width: 768px)": {
    "paddingLeft": "0px",
    "paddingRight": "0px"
  }
});

var ImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cardprimary__ImageWrapper",
  componentId: "sc-1y6la3x-1"
})({
  "position": "absolute",
  "top": "-2.5rem",
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "height": "5rem",
  "width": "5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "alignSelf": "center",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(73 41 131 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "boxShadow": "8px 7px 34px 0px rgba(48, 21, 96, 0.12)"
});

var Header = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cardprimary__Header",
  componentId: "sc-1y6la3x-2"
})(["", " ", " ", ""], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "0.25rem",
  "textAlign": "center"
}, function (_ref3) {
  var showRestaurant = _ref3.showRestaurant;
  return showRestaurant ? {
    "marginTop": "1.75rem"
  } : {};
}, function (_ref4) {
  var twStyle = _ref4.twStyle;
  return twStyle;
});

var SeasonalAccommodation = function SeasonalAccommodation() {
  return /*#__PURE__*/_jsx(_StyledDiv2, {
    children: /*#__PURE__*/_jsxs(_StyledSpan, {
      children: [/*#__PURE__*/_jsx(_StyledHomeIcon, {}), /*#__PURE__*/_jsx(_StyledSpan2, {
        children: "Alloggio Incluso"
      }), /*#__PURE__*/_jsx("span", {
        role: "img",
        "aria-label": "starred-face",
        children: "\uD83E\uDD29"
      })]
    })
  });
};

var ViolaBadge = function ViolaBadge() {
  return /*#__PURE__*/_jsx(_StyledDiv3, {
    children: /*#__PURE__*/_jsxs(_StyledSpan3, {
      className: "group",
      onClick: function onClick() {
        return window.open('https://donnexstrada.org/punti-viola/', '_blank');
      },
      children: [/*#__PURE__*/_jsx(Image, {
        src: getAssetSrc('/utils-assets/logo-dxs.png'),
        width: 80,
        height: 30,
        alt: "Donnexstrada Punti Viola"
      }), /*#__PURE__*/_jsx(_StyledSpan4, {
        children: "Lo staff \xE8 formato contro la violenza di genere"
      })]
    })
  });
}; // --> type


export * from './card.mocks';

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "cardprimary___StyledImage",
  componentId: "sc-1y6la3x-3"
})({
  "height": "100%",
  "width": "100%",
  "borderRadius": "0.5rem",
  "objectFit": "cover",
  "objectPosition": "center"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cardprimary___StyledDiv",
  componentId: "sc-1y6la3x-4"
})({
  "maxWidth": "12rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cardprimary___StyledDiv2",
  componentId: "sc-1y6la3x-5"
})({
  "marginBottom": "1rem",
  "display": "flex",
  "flexDirection": "row",
  "justifyContent": "center"
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "cardprimary___StyledSpan",
  componentId: "sc-1y6la3x-6"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem"
});

var _StyledHomeIcon = /*#__PURE__*/_styled(HomeIcon).withConfig({
  displayName: "cardprimary___StyledHomeIcon",
  componentId: "sc-1y6la3x-7"
})({
  "height": "1rem",
  "width": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))"
});

var _StyledSpan2 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "cardprimary___StyledSpan2",
  componentId: "sc-1y6la3x-8"
})({
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cardprimary___StyledDiv3",
  componentId: "sc-1y6la3x-9"
})({
  "marginTop": "0.5rem",
  "marginBottom": "0.5rem",
  "display": "flex",
  "flexDirection": "row",
  "justifyContent": "center"
});

var _StyledSpan3 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "cardprimary___StyledSpan3",
  componentId: "sc-1y6la3x-10"
})({
  "display": "flex",
  "width": "100%",
  "cursor": "pointer",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "padding": "0.75rem",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(226 216 243 / var(--tw-bg-opacity))"
  }
});

var _StyledSpan4 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "cardprimary___StyledSpan4",
  componentId: "sc-1y6la3x-11"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))",
  ".group:hover &": {
    "--tw-text-opacity": "1",
    "color": "rgb(73 41 131 / var(--tw-text-opacity))"
  }
});